import CardHeading from '@commons/headings/card'
import Column from '@components/column'
import Circle from '@components/circle'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Appointment } from '@apis'
import Typography from '@components/typography'
import Table from '@components/table'
import Row from '@components/row'
import Image from '@components/image'
import { format } from 'date-fns'
import Status from '@commons/status'
import TableActions from '@components/table/actions'
import { useNavigate } from 'react-router-dom'
import debounce from '@utils/debounce'
import Button from '@components/button'
const List = () => {
  const navigate = useNavigate()
  const [params, setParams] = useState({
    page: 1,
    limit: 5,
    search: null,
  })
  const {
    items: appointments,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: any) => state.consultAppointments)

  const fetchData = async (params, action = 'set') => {
    await Appointment.list({
      params,
      state: 'consultAppointments',
      action,
    }).catch(() => {})
  }

  const onSearch = debounce(async (event) => {
    const updateParams = {
      ...params,
      search: event.target.value,
    }
    await fetchData(updateParams)
    setParams(updateParams)
  }, 600)

  const columns = [
    {
      key: 'id',
      title: 'Id',
      render: (item) => {
        return `#${item?.id}`
      },
    },
    {
      key: 'patient',
      title: 'Patient',
      render: (item) => {
        return (
          <Row colGap={10}>
            <Image
              fallbackType="user"
              width={30}
              height={30}
              styleImage={'border-radius:50%;'}
              src={`${process.env.BUCKET_URL}/${item?.patient.avatar}`}
            />
            <Column>
              <Typography content={item?.patient?.name} />
              <Typography content={item?.patient?.phoneNo} />
            </Column>
          </Row>
        )
      },
    },
    {
      key: 'doctor',
      title: 'Doctor',
      render: (item) => {
        return (
          <Row colGap={10}>
            <Image
              fallbackType="user"
              width={30}
              height={30}
              styleImage={'border-radius:50%;'}
              src={`${process.env.BUCKET_URL}/${item?.appointmentWith.avatar}`}
            />
            <Column>
              <Typography content={item?.appointmentWith?.name} />
              <Typography content={item?.appointmentWith?.phoneNo} />
            </Column>
          </Row>
        )
      },
    },
    {
      key: 'appointmentType',
      title: 'Appointment Type',
      render: (item) => {
        return item?.infos?.appointmentType
      },
    },
    {
      key: 'date',
      title: 'Date',
      render: (item) => {
        return format(item?.date, 'MMM dd yyyy HH:mm aa')
      },
    },
    {
      key: 'status',
      title: 'Status',
      render: (item: any) => {
        return <Status status={item?.status} />
      },
    },
    {
      key: 'action',
      title: 'Actions',
      render: (item) => {
        return (
          <TableActions
            hasEdit={false}
            hasDelete={false}
            onClickView={() => {
              navigate(`/institution/appointments/details-${item?.id}`)
            }}
          />
        )
      },
    },
  ]

  useEffect(() => {
    if (!appointments?.length) {
      fetchData(params)
    }
  }, [])
  return (
    <Column rowGap={20}>
      <CardHeading
        title="All Appointments"
        titleRightComponent={
          <Circle bg="secondary" size={20}>
            <Typography content={totalItems || '0'} size={12} tc="white" />
          </Circle>
        }
      />
      <Table
        data={appointments}
        columns={columns}
        filter={{
          hasSearch: true,
          isServerSide: true,
          onSearch: onSearch,
        }}
      />
      {params?.page < totalPages && (
        <Column alignItems="center">
          <Button
            title="Load More"
            outline
            onClick={async () => {
              const updateParams = {
                ...params,
                page: params?.page + 1,
              }

              await fetchData(updateParams, 'append')
              setParams(updateParams)
            }}
          />
        </Column>
      )}
    </Column>
  )
}

export default List
